<template>
    <v-row>
        <v-col cols="12" lg="" class="pb-0">
            <v-file-input v-model="temp" :label="label" dense outlined persistent-placeholder messages="첨부버튼을 누르셔야 정상 등록됩니다." />
        </v-col>
        <v-col cols="12" lg="auto" class="pb-0">
            <v-btn @click="addFile" block color="secondary" elevation="0" class="py-5">첨부</v-btn>
        </v-col>
        <v-col cols="12" class="py-0">
            <v-chip-group v-model="value" multiple>
                <v-chip v-for="(file, i) in value" :key="i" :value="file" outlined color="primary" class="rounded">
                    <span>{{ file.name }}</span>
                    <v-icon small>mdi-close</v-icon>
                </v-chip>
            </v-chip-group>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props: ["value", "label"],
    data() {
        return { temp: null };
    },
    methods: {
        addFile() {
            if (this.temp) {
                this.$emit("input", [...this.value, this.temp]);
                this.temp = null;
            } else alert("파일을 추가하세요.");
        },
    },
};
</script>

<style></style>
